export const defaultState = {
  publicHolidays: [],
  myLeavePlans: [],
  myOtherLeaveRequests: [],
  leaveTypes: [],
};
